import "./css/login.css"
import { Link, useNavigate } from "react-router-dom"
import { useState, useEffect } from "react"

const SignUp = () => {
    const navigate = useNavigate()
    const pageName = "Sign Up"
    const [showPasswordverify, setShowPassowrdVerify] = useState(false)
    const [showPassword, setShowPassword] = useState(false)
    const [closeErrorMessage, setCloseErrorMessage] = useState(false)
    const [errorMessage, setErrorMessage] = useState()
    
    const [name, setName] = useState("")
    const [mail, setMail] = useState("")
    const [password, setPassword] = useState("")
    const [verify, setVerify] = useState("")
    
    const [nameError, setNameError] = useState("")
    const [mailError, setMailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [verifyError, setVerifyError] = useState("")

    // Fix 1: Added [navigate] dependency to prevent infinite loops
    useEffect(() => {
        if (
            localStorage.getItem("name") !== null
            && localStorage.getItem("email") !== null
            && localStorage.getItem("status") !== null
            && localStorage.getItem("token") !== null
            && localStorage.getItem("user_id") !== null
        ) {
            navigate("/profile")
        } else if (
            localStorage.getItem("name") === null
            || localStorage.getItem("email") === null
            || localStorage.getItem("status") === null
            || localStorage.getItem("token") === null
            || localStorage.getItem("user_id") === null
        ) {
            localStorage.clear();
        }
    }, [navigate])

    // Fix 2: Added event listener to clear errors when the user starts typing
    useEffect(() => {
        const handleKeyDown = () => {
            if (name.length > 0) setNameError("");
            if (mail.length > 0) setMailError("");
            if (password.length > 0) setPasswordError("");
            if (verify.length > 0) setVerifyError("");
        };
        window.addEventListener("keypress", handleKeyDown);
        return () => window.removeEventListener("keypress", handleKeyDown);
    }, [name, mail, password, verify])

    const clearErrors = () => {
        setNameError("");
        setMailError("");
        setPasswordError("");
        setVerifyError("");
    };

    const validateClientSide = () => {
        let isValid = true;
        clearErrors();

        if (!name.trim()) {
            setNameError("Enter your name.");
            isValid = false;
        } else if (name.length < 3) {
            setNameError("Minimum character length is 3.");
            isValid = false;
        } else if (name.length > 20) {
            setNameError("Maximum character length is 20.");
            isValid = false;
        }

        if (!mail.trim()) {
            setMailError("Enter your E-mail address.");
            isValid = false;
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(mail)) {
            setMailError("Your Email format is not valid.");
            isValid = false;
        }

        if (!password) {
            setPasswordError("Enter your password.");
            isValid = false;
        } else if (password.length < 6) {
            setPasswordError("Enter password at least 6 characters.");
            isValid = false;
        } else if (password.length > 25) {
            setPasswordError("Maximum password length is 25 characters.");
            isValid = false;
        }

        if (!verify) {
            setVerifyError("Confirm your password.");
            isValid = false;
        } else if (password !== verify) {
            setVerifyError("Passwords do not match.");
            isValid = false;
        }

        return isValid;
    };

    const submit = async (e) => {
        if(e) e.preventDefault();
        if (!validateClientSide()) return; 

        const data = {
            name: name.trim(),
            mail: mail.trim(),
            password: password.trim(),
            verify: verify.trim()
        }

        // Fix 3 & 4: Added try-catch for Network Error Handling & HTTP Status validation
        try {
            const response = await fetch(process.env.REACT_APP_SERVER_URL + "/user/signup", {
                method: "POST",
                body: JSON.stringify(data),
                headers: {
                    "Content-Type": "application/json"
                }
            })

            const result = await response.json()

            // Handle HTTP errors like 429 (Rate Limit) or 500
            if (!response.ok || result.status === false) {
                setErrorMessage(result.message || "Registration failed. Please check your details.");
                setCloseErrorMessage(true);
                
                // Handle express-validator specific errors if they exist
                if (result.error) {
                    result.error.forEach((item) => {
                        if ("name" === item.path) setNameError(item.msg)
                        if ("mail" === item.path) setMailError(item.msg)
                        if ("password" === item.path) setPasswordError(item.msg)
                        if ("verify" === item.path) setVerifyError(item.msg)
                    });
                }
                return;
            }

            // Success case
            if (result.status === true) {
                localStorage.clear()
                localStorage.setItem("signtoken", result.signtoken)
                localStorage.setItem("name", result.response.name)
                localStorage.setItem("mail", result.response.email)
                localStorage.setItem("user_id", result.response.user_id)
                localStorage.setItem("token", result.response.token)
                localStorage.setItem("key", result.response.key)
                localStorage.setItem("status", result.response.status)
                navigate("/signupVerification")
            }

        } catch (error) {
            console.error("Signup Error: ", error);
            setErrorMessage("Error connecting to the server. Please try again later.");
            setCloseErrorMessage(true);
        }
    }

    return (
        <div className="authPageWrapper">
            <div className="authMainContainer">
                <div className="authImageSection singUpImageBg">
                    {/* Image goes here via CSS */}
                </div>

                <div className="authFormSection">
                    <div className="authFormHeader">
                        <h2>Create Account</h2>
                        <p>Sign up to get started</p>
                    </div>

                    <form className="authForm" onSubmit={submit}>
                        
                        <div className="inputGroup">
                            <label htmlFor="name">Name</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-user inputIcon"></i>
                                <input type="text"
                                    id="name"
                                    name="username"
                                    value={name}
                                    placeholder="Enter your name"
                                    autoComplete="off"
                                    autoFocus
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                            {nameError && <span className="errorText">{nameError}</span>}
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="email">E-mail</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-envelope inputIcon"></i>
                                <input type="text"
                                    id="email"
                                    name="usermail"
                                    value={mail}
                                    placeholder="Enter your email"
                                    autoComplete="off"
                                    onChange={(e) => setMail(e.target.value)}
                                />
                            </div>
                            {mailError && <span className="errorText">{mailError}</span>}
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="password">Password</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-lock inputIcon"></i>
                                <input type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="userpassowd"
                                    value={password}
                                    placeholder="Create password"
                                    autoComplete="off"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                                <button type="button" className="passwordToggle" onClick={() => setShowPassword(!showPassword)}>
                                    {showPassword ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                                </button>
                            </div>
                            {passwordError && <span className="errorText">{passwordError}</span>}
                        </div>

                        <div className="inputGroup">
                            <label htmlFor="verify">Confirm Password</label>
                            <div className="inputWrapper">
                                <i className="fa-solid fa-lock inputIcon"></i>
                                <input type={showPasswordverify ? "text" : "password"}
                                    id="verify"
                                    name="userverify"
                                    value={verify}
                                    placeholder="Confirm password"
                                    autoComplete="off"
                                    onChange={(e) => setVerify(e.target.value)}
                                />
                                <button type="button" className="passwordToggle" onClick={() => setShowPassowrdVerify(!showPasswordverify)}>
                                    {showPasswordverify ? <i className="fa-solid fa-eye-slash"></i> : <i className="fa-solid fa-eye"></i>}
                                </button>
                            </div>
                            {verifyError && <span className="errorText">{verifyError}</span>}
                        </div>

                        <button type="submit" className="submitBtn">{pageName}</button>

                        <div className="authFormFooter">
                            <p>Already have an account? <Link to="/login">Login</Link></p>
                        </div>
                    </form>
                </div>
            </div>

            {closeErrorMessage && (
                <div className="authModalOverlay">
                    <div className="authModalBox">
                        <i className="fa-solid fa-circle-exclamation errorIcon"></i>
                        <p className="modalMessage">{errorMessage}</p>
                        <button className="modalBtn" onClick={() => setCloseErrorMessage(false)}>Ok</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default SignUp